import React, {useEffect, useState} from "react";
import useAxios from "axios-hooks";
import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  PrimaryButton,
  TextField,
  MessageBar,
  MessageBarType,
} from "@fluentui/react";

const CloneChecklistModal = ({
  showModal,
  toggleShowModal,
  onClone,
  checklistId,
  onNavigate,
}) => {
  const [slug, setSlug] = useState("");
  const [{data, loading, error }, executeClone] = useAxios(
    {
      method: "post",
      url: `/checklist/${checklistId}/clone`,
    },
    { manual: true }
  );

  useEffect(()=>{
      if(!loading && data && !error){
          if(data.checklistID && onNavigate) {
              // Navigate to the new checklist - don't refetch since we're leaving the page
              onNavigate(data.checklistID);
          } else {
              // Only refetch if we're staying on the list page
              onClone && onClone();
          }
          toggleShowModal();
      }
  },[loading, data, error])

  return (
    <Dialog
      hidden={!showModal}
      onDismiss={toggleShowModal}
      modalProps={{
        isBlocking: true,
      }}
      dialogContentProps={{
        type: DialogType.normal,
        title: "Clone Checklist",
        subText: "Please enter a new slug for the cloned checklist",
      }}
    >
      <MessageBar messageBarType={MessageBarType.info} styles={{ root: { marginBottom: '15px' } }}>
        <strong>Slug Requirements:</strong>
        <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
          <li>Must be lowercase letters only (a-z)</li>
          <li>Can include numbers (0-9) and underscores (_)</li>
          <li>Can use hyphens (-) to separate words</li>
          <li>No spaces or special characters allowed</li>
        </ul>
        <strong>Examples:</strong> my-checklist, student_checklist, financial-wellness-101
      </MessageBar>
      <TextField
        label="Enter the new slug for this checklist"
        placeholder="e.g., my-checklist-name"
        onChange={(e, newValue) => setSlug(newValue)}
        onGetErrorMessage={(value) => {
          if (!value) {
            return "Slug is required";
          }
          if (!isValidSlug(value)) {
            return "Invalid slug format. Must be lowercase letters, numbers, underscores, and hyphens only.";
          }
          return "";
        }}
        value={slug}
        required
      />
      <DialogFooter>
        <PrimaryButton
          onClick={async () => {
            try {
              if (isValidSlug(slug)) {
                await executeClone({ data: { Slug: slug } });
              }
            } catch (e) {
              throw e;
            }
          }}
          text="Clone"
          disabled={!slug || !isValidSlug(slug) || loading}
        />
        <DefaultButton
          disabled={loading}
          onClick={toggleShowModal}
          text="Cancel"
        />
      </DialogFooter>
    </Dialog>
  );
};

function isValidSlug(slug){
   return slug.match(/^[a-z0-9_]+(-[a-z0-9_]+)*$/)?.length
}

export default CloneChecklistModal;
